export const getOrigin = () => window.location.origin;
